import React from 'react';
import useSessionCompliance from './useSessionCompliance';
import { SessionComplianceContext } from './useSessionComplianceContext';

export default function SessionComplianceContextProvider({ children }: { children: React.ReactNode }) {
  const complianceChecklist = useSessionCompliance();
  return (
    <SessionComplianceContext.Provider value={complianceChecklist}>
      {children}
    </SessionComplianceContext.Provider>
  );
}
